import React, { useEffect, useRef, useState } from 'react';

import { DrawerPdfLetter, DrawerPdfLetterProps } from './DrawerPdfLetter';
import { button, modalBackdrop, modalContainer } from './drawerStyles';
import { generateDrawerLetter } from './generateDrawerLetter';

export interface LetterPreviewModalProps {
  open: boolean;
  onClose: () => void;
  pdfProps: DrawerPdfLetterProps | null;
}

export const LetterPreviewModal = ({ open, onClose, pdfProps }: LetterPreviewModalProps) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const blobUrlRef = useRef<string | null>(null);

  useEffect(() => {
    if (!open || !pdfProps) return;
    let cancelled = false;
    setBlobUrl(null);
    setError(null);

    generateDrawerLetter(pdfProps).then(files => {
      if (cancelled) return;
      const url = URL.createObjectURL(files[0]);
      blobUrlRef.current = url;
      setBlobUrl(url);
    }).catch(() => {
      if (!cancelled) setError('Failed to generate preview.');
    });

    return () => {
      cancelled = true;
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
        blobUrlRef.current = null;
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, pdfProps]);

  if (!open || !pdfProps) return null;

  return (
    <div style={modalBackdrop} onClick={onClose}>
      <div
        style={{ ...modalContainer, maxWidth: 820, height: '85vh', display: 'flex', flexDirection: 'column' }}
        onClick={e => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '11px 16px',
            borderBottom: '1px solid #D8D7CE',
            background: '#F0EFE9',
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 500 }}>Letter preview</span>
          <button type="button" style={button} onClick={onClose}>
            Close
          </button>
        </div>
        <div style={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {error ? (
            <span style={{ color: '#991B1B', fontSize: 13 }}>{error}</span>
          ) : blobUrl ? (
            <iframe
              src={blobUrl}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title="Letter preview"
            />
          ) : (
            <span style={{ fontSize: 13, color: '#6B7280' }}>Generating preview…</span>
          )}
        </div>
      </div>
    </div>
  );
};
